export const SocialData = [
  {
    platform: "Instagram",
    icon: "instagram",
    link: "https://www.instagram.com/sergio_omar_sanchez/",
  },
  {
    platform: "Github",
    icon: "github",
    link: "https://github.com/sergioomarsanchez",
  },
  {
    platform: "Youtube",
    icon: "youtube",
    link: "https://www.youtube.com/channel/UChUh9vc9sCKwjRV7_-P8YnA",
  },
  {
    platform: "LinkedIn",
    icon: "linkedin",
    link: "https://www.linkedin.com/in/sergio-omar-sanchez-6ba362104",
  },
  {
    platform: "Mailto",
    icon: "mail",
    link: "mailto:sanchez.omar.sergio@gmail.com",
  },
];
